import React, {Component} from 'react'

import {InputAdornment} from '@material-ui/core'

import CVVHelp from '../CVVHelp'
import MaskInput from '../../../../shared/components/MaskInput'
import withValidation from '../../../../container/withValidation'
import CustomTextField from '../CustomTextField'
import size from 'lodash/size'
import head from 'lodash/head'

function determineIsAmex(paymentMethod, paymentMethodId) {
    return parseInt((size(paymentMethod) === 1 && head(paymentMethod)) || paymentMethodId) === 65 || parseInt((size(paymentMethod) === 1 && head(paymentMethod)) || paymentMethodId) === 111
}

class CVVInput extends Component {

    handleChange = (e) => {
        const inputValue = e.target.value;
        this.props.updateCardData({key: 'security_code', value: inputValue});
        this.props.onChange(e)
    }

    getMask = (isAmex) => isAmex ? "9999" : "999"

    render() {
        const {errorMessage, paymentMethod, paymentMethodId, error, tabIndex, ...restOfProps} = this.props
        const isAmex = determineIsAmex(paymentMethod, paymentMethodId)
        const mask = this.getMask(isAmex)

        return (
            <MaskInput
                mask={mask}
                onPaste={e => e.preventDefault()}
                {...restOfProps}
                onChange={this.handleChange}
            >
                <CustomTextField
                    id="securityCode"
                    label="CVV"
                    type="text"
                    name="card_data.security_code"
                    helperText={`Ingresá los ${mask.length} números`}
                    errorMessage={errorMessage}
                    InputProps={{
                        endAdornment:
                            <InputAdornment position="end">
                                <CVVHelp isAmex={isAmex} />
                            </InputAdornment>
                    }}
                    error={error}
                    tabIndex={tabIndex}/>
            </MaskInput>
        )
    }

}

const validation = (value, props) => {
    if (value.length === 0) return {
        isValid: false,
        message: "Completa este dato"
    }

    const valid = determineIsAmex(props.paymentMethod, props.paymentMethodId) ? value.length === 4 : value.length === 3
    return {
        isValid: valid,
        message: valid ? "" : "Encontramos un error en este dato"
    }
}

export default withValidation(validation)(CVVInput)
